export default [
  // 用户管理-列表查询
  {
    url: "/mock/user/getUserListByCondition",
    response: {"item":[{"userid":13,"username":"鑫鑫","password":"$2a$10$LXqO.whvFBKIxFSZMAeha./.1fzFgYuxritcfeXuAO4xRE0tKrYM2","useraccount":"test123","sex":0,"status":1,"phonenum":"18253434343","telnum":"25324","idnum":"234324324","email":"123@email.com","expiretime":"20191031","istest":1,"areaid":"130102","usertype":0,"levelid":1,"userdesc":"ddd","userdepid":1,"maintenancegroupid":0,"maintenancenum":"","certificate1num":"sssdfsdf","certificate1starttime":"20201017","certificate1endtime":"20201017","certificate1pic":"file/pc/20201025102202736.png","certificate2num":"234324324","certificate2starttime":"20201017","certificate2endtime":"20201112","certificate2pic":"file/pc/20201025102212998.png","qualificationdesc":"fff","coordinatetime":"","address":"","createtime":"20201025182330","updatetime":"20201025102330","roleList":null,"url":null,"roles":null,"authorities":null,"accountNonExpired":true,"accountNonLocked":true,"credentialsNonExpired":true,"enabled":true,"apptype":0},{"userid":12,"username":"yanlei","password":"$2a$10$JKVWkXNLw9VR5cyk54ZIouGShmhsZ7/Q3LAL5.QX37aJUx4F1gVVW","useraccount":"yl","sex":1,"status":1,"phonenum":"13182970083","telnum":"","idnum":"","email":"","expiretime":null,"istest":0,"areaid":"330206","usertype":0,"levelid":1,"userdesc":null,"userdepid":0,"maintenancegroupid":0,"maintenancenum":null,"certificate1num":null,"certificate1starttime":null,"certificate1endtime":null,"certificate1pic":null,"certificate2num":null,"certificate2starttime":null,"certificate2endtime":null,"certificate2pic":null,"qualificationdesc":null,"coordinatetime":null,"address":null,"createtime":"20201024224431","updatetime":"20201024144431","roleList":null,"url":null,"roles":null,"authorities":null,"accountNonExpired":true,"accountNonLocked":true,"credentialsNonExpired":true,"enabled":true,"apptype":0},{"userid":1,"username":"Admin","password":"$2a$10$ekoXHfrqY6ljCxgFN2Rdqe2hifFlUusIjrXCeTT4dd6BHf38ox.5y","useraccount":"admin","sex":0,"status":0,"phonenum":"18251123234","telnum":"02586523456","idnum":"340824198311116430","email":"tcy@163.com","expiretime":"20201007","istest":0,"areaid":"0001237898","usertype":0,"levelid":0,"userdesc":"测试账号","userdepid":0,"maintenancegroupid":0,"maintenancenum":"33","certificate1num":"33","certificate1starttime":"20201017","certificate1endtime":"20201017","certificate1pic":"33","certificate2num":"33","certificate2starttime":"20201017","certificate2endtime":"20201017","certificate2pic":"33","qualificationdesc":"33","coordinatetime":"33","address":"333","createtime":"20201022080228","updatetime":"20201022000230","roleList":null,"url":null,"roles":null,"authorities":null,"accountNonExpired":true,"accountNonLocked":true,"credentialsNonExpired":true,"enabled":true,"apptype":0},{"userid":11,"username":"xingming","password":"$2a$10$x/KuGq2.fwjyJeAIvYvkg.9hIoxPR9foegz5csK87b.CwimWVJvDe","useraccount":"quji","sex":1,"status":1,"phonenum":"18252343243","telnum":"23432423432","idnum":"234324324324","email":"zhaoxin@jsxhyj.cn","expiretime":"20191031","istest":0,"areaid":"150102","usertype":3,"levelid":2,"userdesc":"miaoshu","userdepid":1,"maintenancegroupid":1,"maintenancenum":"123123","certificate1num":"zuoyezheng","certificate1starttime":"20201008","certificate1endtime":"20201017","certificate1pic":"file/pc/20201021215329159.png","certificate2num":"sijizheng","certificate2starttime":"20201017","certificate2endtime":"20201031","certificate2pic":"file/pc/20201021215405100.png","qualificationdesc":"zizhimiaoshu","coordinatetime":"111","address":"xiangxidizhi","createtime":"20201022060239","updatetime":"20201021220242","roleList":null,"url":null,"roles":null,"authorities":null,"accountNonExpired":true,"accountNonLocked":true,"credentialsNonExpired":true,"enabled":true,"apptype":0},{"userid":8,"username":"赵鑫","password":"$2a$10$90khBs3oIAd40BmiLjCBbOaQzVbRuWXTNFpOeNkS8RlakRk2rgX76","useraccount":"zx","sex":1,"status":1,"phonenum":"17312237975","telnum":"","idnum":"","email":"","expiretime":null,"istest":0,"areaid":"220113","usertype":0,"levelid":1,"userdesc":null,"userdepid":0,"maintenancegroupid":0,"maintenancenum":null,"certificate1num":null,"certificate1starttime":null,"certificate1endtime":null,"certificate1pic":null,"certificate2num":null,"certificate2starttime":null,"certificate2endtime":null,"certificate2pic":null,"qualificationdesc":null,"coordinatetime":null,"address":null,"createtime":"20201021050308","updatetime":"20201020210309","roleList":null,"url":null,"roles":null,"authorities":null,"accountNonExpired":true,"accountNonLocked":true,"credentialsNonExpired":true,"enabled":true,"apptype":0},{"userid":7,"username":"fyn8","password":"fyn7","useraccount":"fyn8","sex":1,"status":1,"phonenum":"13775184727","telnum":"02884562764","idnum":"340824198311116430","email":"tcy1@126.com","expiretime":"20201009","istest":1,"areaid":"01","usertype":0,"levelid":1,"userdesc":"测试1","userdepid":2,"maintenancegroupid":2,"maintenancenum":"33","certificate1num":"33","certificate1starttime":"20201009","certificate1endtime":"20201009","certificate1pic":"/url/pic2","certificate2num":"33","certificate2starttime":"20201009","certificate2endtime":"20201009","certificate2pic":"/url/pic2","qualificationdesc":"/url/pic2","coordinatetime":"33","address":"淮海路1","createtime":"20201019013114","updatetime":"20201018173105","roleList":null,"url":null,"roles":null,"authorities":null,"accountNonExpired":true,"accountNonLocked":true,"credentialsNonExpired":true,"enabled":true,"apptype":0},{"userid":4,"username":"fyn1","password":"fyn1","useraccount":"fyn3","sex":1,"status":1,"phonenum":"13775184727","telnum":"02884562764","idnum":"340824198311116430","email":"tcy1@126.com","expiretime":"20201009","istest":1,"areaid":"01","usertype":0,"levelid":1,"userdesc":"测试1","userdepid":2,"maintenancegroupid":2,"maintenancenum":"33","certificate1num":"33","certificate1starttime":"20201009","certificate1endtime":"20201009","certificate1pic":"/url/pic2","certificate2num":"33","certificate2starttime":"20201009","certificate2endtime":"20201009","certificate2pic":"/url/pic2","qualificationdesc":"/url/pic2","coordinatetime":"33","address":"淮海路1","createtime":"20201018054139","updatetime":"20201017080000","roleList":null,"url":null,"roles":null,"authorities":null,"accountNonExpired":true,"accountNonLocked":true,"credentialsNonExpired":true,"enabled":true,"apptype":0}],"returncode":"0","count":7,"errormsg":"ok"}
    // response: {
    //   "returncode": "0",
    //   "errormsg": "",
    //   'count|30-200': 1,
    //   "item|3-10": [
    //     {
    //       "userid|+1": 10001,
    //       "useraccount": '@word(5,8)',
    //       'username': '@cname(2,3)',
    //       'userdepid': '@word(10)',
    //       'userdepname': '@cword(5,10)',
    //       'email': '@email',
    //       'status|1': [0,1]
    //     }
    //   ]
    // }
  },
  // 用户管理-删除
  {
    url: "/mock/user/deleteUser",
    response: {
      "returncode|+1": ["0", "1"],
      "errormsg|+1": ["删除成功", "删除失败"]
    }
  },
  // 用户管理-新增
  {
    url: "/mock/user/addUser",
    response: {
      "returncode|+1": ["0", "1"],
      "errormsg|+1": ["新增成功", "新增失败"]
    }
  },
  // 用户管理-修改
  {
    url: "/mock/user/modifyUser",
    response: {
      "returncode|+1": ["0", "1"],
      "errormsg|+1": ["修改成功", "修改失败"]
    }
  },
  // 用户管理-用户角色查询
  {
    url: '/mock/role/getRoleListByUserid',
    response: {"item":[{"roleid":1,"roledesc":"维护组","rolename":"维护组","roletype":3,"menus":null},{"roleid":3,"roledesc":"管理员维护","rolename":"管理员维护","roletype":0,"menus":null},{"roleid":7,"roledesc":"","rolename":"授权测试","roletype":0,"menus":null}],"returncode":"0","errormsg":"ok"}
  },
  // 用户管理-用户详情查询
  {
    url: '/mock/user/getUserByUserid',
    response: {"item":{"userid":13,"username":"鑫鑫","password":"$2a$10$LXqO.whvFBKIxFSZMAeha./.1fzFgYuxritcfeXuAO4xRE0tKrYM2","useraccount":"test123","sex":0,"status":1,"phonenum":"18253434343","telnum":"25324","idnum":"234324324","email":"123@email.com","expiretime":"20191031","istest":1,"areaid":"130102","usertype":0,"levelid":1,"userdesc":"ddd","userdepid":1,"maintenancegroupid":0,"maintenancenum":"","certificate1num":"sssdfsdf","certificate1starttime":"20201017","certificate1endtime":"20201017","certificate1pic":"file/pc/20201025102202736.png","certificate2num":"234324324","certificate2starttime":"20201017","certificate2endtime":"20201112","certificate2pic":"file/pc/20201025102212998.png","qualificationdesc":"fff","coordinatetime":"","address":"","createtime":"20201025182330","updatetime":"20201025102330","roleList":[{"roleid":7,"roledesc":"","rolename":"授权测试","roletype":0,"menus":null}],"url":null,"roles":null,"authorities":null,"accountNonExpired":true,"accountNonLocked":true,"credentialsNonExpired":true,"enabled":true,"apptype":0},"returncode":"0","errormsg":"ok"}
  },
  // 用户管理-分配角色
  {
    url: '/mock/role/authRole',
    response: {
      "returncode|+1": ["0", "1"],
      "errormsg|+1": ["操作成功", "操作失败"]
    }
  },
  // 用户管理-个人信息修改
  {
    url: '/mock/user/modifyPersonInfo',
    response: {
      "returncode|+1": ["0", "1"],
      "errormsg|+1": ["操作成功", "操作失败"]
    }
  },
  // 用户管理-重置密码
  {
    url: '/mock/user/resetPassword',
    response: {
      "returncode|+1": ["0", "1"],
      "errormsg|+1": ["操作成功", "操作失败"]
    }
  },
  // 角色管理-列表查询
  {
    url: "/mock/role/getRoleListByCondition",
    response: {
      "returncode": "0",
      "errormsg": "",
      'count|30-200': 1,
      "item|3-10": [
        {
          "roleid|+1": 10001,
          'roletype|1': [0,1,2,3],//(0-超级管理员,1-物业，2-监管，3-维保)
          "rolename": '@word(5,8)',
          'roledesc': '描述@cword(5,10)',
          'menus': []
        }
      ]
    }
  },
  // 角色管理-删除
  {
    url: "/mock/role/deleteRole",
    response: {
      "returncode|+1": ["0", "1"],
      "errormsg|+1": ["删除成功", "删除失败"]
    }
  },
  // 角色管理-新增
  {
    url: "/mock/role/addRole",
    response: {
      "returncode|+1": ["0", "1"],
      "errormsg|+1": ["新增成功", "新增失败"]
    }
  },
  // 角色管理-修改
  {
    url: "/mock/role/modifyRole",
    response: {
      "returncode|+1": ["0", "1"],
      "errormsg|+1": ["修改成功", "修改失败"]
    }
  },
  // 菜单管理-菜单查询
  {
    url: "/mock/menu/getAllMenuTree",
    response: {
      "returncode": "0",
      "errormsg": "ok",
      "item":[
        {
          "menuid":1,
          "menucode":"000",
          "parentmenuid":"",
          "menuname":"系统配置",
          "menuurl":"",
          "menutype":1,
          "menuno":1,
          "status":0,
          "apptype":0,
          "menudesc":"系统配置",
          "children":[
            {
              "menuid":100,
              "menucode":"100",
              "parentmenuid":1,
              "menuname":"用户管理",
              "menuurl":"",
              "menutype":1,
              "menuno":1,
              "status":0,
              "apptype":0,
              "menudesc":"用户管理",
              "children":[
                {
                  "menuid":101,
                  "menucode":"101",
                  "parentmenuid":100,
                  "menuname":"人员管理",
                  "menuurl":"peopleManagement",
                  "menutype":1,
                  "menuno":1,
                  "status":0,
                  "apptype":0,
                  "menudesc":"人员管理",
                  "children":[]
                },
                {
                  "menuid":102,
                  "menucode":"102",
                  "parentmenuid":100,
                  "menuname":"维保组管理",
                  "menuurl":"maintenanceGroupManagement",
                  "menutype":1,
                  "menuno":2,
                  "status":0,
                  "apptype":0,
                  "menudesc":"维保组管理",
                  "children":[]
                },
              ]
            },
            {
              "menuid":110,
              "menucode":"110",
              "parentmenuid":1,
              "menuname":"角色管理",
              "menuurl":"roleManagement",
              "menutype":1,
              "menuno":2,
              "status":0,
              "apptype":0,
              "menudesc":"角色管理",
              "children":[]
            },
            {
              "menuid":120,
              "menucode":"120",
              "parentmenuid":1,
              "menuname":"菜单管理",
              "menuurl":"menuManagement",
              "menutype":1,
              "menuno":1,
              "status":0,
              "apptype":0,
              "menudesc":"菜单管理",
              "children":[]
            }
          ]
        }
      ],
    }
  },
  // 日志管理-列表查询
  {
    url: "/mock/log/getLogListByCondition",
    response: {
      "returncode": "0",
      "errormsg": "",
      'count|30-200': 1,
      "item|3-10": [
        {
          "logid|+1": 10001,
          "useraccount": '@word(5,8)',
          'logtype|1': [0,1,2,3],//(0-增加,1-删除,2-修改，3-用户登录)
          'logtime': '@datetime("yyyyMMddHHmmss")',
          'logcontent': '@paragraph(3,7)',
        }
      ]
    }
  },
  // 日志管理-删除
  {
    url: "/mock/log/deleteLog",
    response: {
      "returncode|+1": ["0", "1"],
      "errormsg|+1": ["删除成功", "删除失败"]
    }
  },
  // 维护组管理-列表查询
  {
    url: "/mock/mentenacegroup/getMentenacegroupListByCondition",
    response: {
      "item":[
        {
          "maintenancegroupid":6,
          "maintenancegroupname":"测试维护组8",
          "adminid":7,
          "adminname":"fyn8",
          "groupmenid":8,
          "groupmenname":"赵鑫",
          "maintenancedepid":2,
          "maintenancedepname":null,
          "memberidList":null,
          "memberids":null,
          "memberList":null
        },
        {
          "maintenancegroupid":5,
          "maintenancegroupname":"测试维护组3",
          "adminid":1,
          "adminname":"Admin",
          "groupmenid":4,
          "groupmenname":"fyn1",
          "maintenancedepid":1,
          "maintenancedepname":null,
          "memberidList":null,
          "memberids":null,
          "memberList":null
        }
      ],
      "returncode":"0",
      "count":5,
      "errormsg":"ok"
    }
  },
  // 维护组管理-删除
  {
    url: "/mock/mentenacegroup/deleteMentenacegroup",
    response: {
      "returncode|+1": ["0", "1"],
      "errormsg|+1": ["删除成功", "删除失败"]
    }
  },
  // 维护组管理-新增
  {
    url: "/mock/mentenacegroup/addMentenacegroup",
    response: {
      "returncode|+1": ["0", "1"],
      "errormsg|+1": ["新增成功", "新增失败"]
    }
  },
  // 维护组管理-修改
  {
    url: "/mock/mentenacegroup/modifyMentenacegroup",
    response: {
      "returncode|+1": ["0", "1"],
      "errormsg|+1": ["修改成功", "修改失败"]
    }
  },
  // 维护组管理-查询详情
  {
    url: "/mock/mentenacegroup/getMentenacegroupById",
    response: {
      "item":{
        "maintenancegroupid":6,
        "maintenancegroupname":"测试维护组8",
        "adminid":7,
        "adminname":"fyn8",
        "groupmenid":8,
        "groupmenname":"赵鑫",
        "maintenancedepid":2,
        "maintenancedepname":null,
        "memberidList":null,
        "memberids":null,
        "memberList":[
          {
            "userid":8,
            "username":"赵鑫",
            "password":"$2a$10$90khBs3oIAd40BmiLjCBbOaQzVbRuWXTNFpOeNkS8RlakRk2rgX76",
            "useraccount":"zx",
            "sex":1,
            "status":1,
            "phonenum":"17312237975",
            "telnum":"",
            "idnum":"",
            "email":"",
            "expiretime":null,
            "istest":0,
            "areaid":"220113",
            "usertype":0,
            "levelid":1,
            "userdesc":null,
            "userdepid":0,
            "maintenancegroupid":0,
            "maintenancenum":null,
            "certificate1num":null,
            "certificate1starttime":null,
            "certificate1endtime":null,
            "certificate1pic":null,
            "certificate2num":null,
            "certificate2starttime":null,
            "certificate2endtime":null,
            "certificate2pic":null,
            "qualificationdesc":null,
            "coordinatetime":null,
            "address":null,
            "createtime":"20201021050308",
            "updatetime":"20201020210309",
            "roleList":null,
            "url":null,
            "roles":null,
            "authorities":null,
            "accountNonExpired":true,
            "accountNonLocked":true,
            "credentialsNonExpired":true,
            "enabled":true,
            "apptype":0
          },
          {
            "userid":11,
            "username":"xingming",
            "password":"$2a$10$x/KuGq2.fwjyJeAIvYvkg.9hIoxPR9foegz5csK87b.CwimWVJvDe",
            "useraccount":"quji",
            "sex":1,
            "status":1,
            "phonenum":"18252343243",
            "telnum":"23432423432",
            "idnum":"234324324324",
            "email":"zhaoxin@jsxhyj.cn",
            "expiretime":"20191031",
            "istest":0,
            "areaid":"150102",
            "usertype":3,
            "levelid":2,
            "userdesc":"miaoshu",
            "userdepid":1,
            "maintenancegroupid":1,
            "maintenancenum":"123123",
            "certificate1num":"zuoyezheng",
            "certificate1starttime":"20201008",
            "certificate1endtime":"20201017",
            "certificate1pic":"file/pc/20201021215329159.png",
            "certificate2num":"sijizheng",
            "certificate2starttime":"20201017",
            "certificate2endtime":"20201031",
            "certificate2pic":"file/pc/20201021215405100.png",
            "qualificationdesc":"zizhimiaoshu",
            "coordinatetime":"111",
            "address":"xiangxidizhi",
            "createtime":"20201022060239",
            "updatetime":"20201021220242",
            "roleList":null,
            "url":null,
            "roles":null,
            "authorities":null,
            "accountNonExpired":true,
            "accountNonLocked":true,
            "credentialsNonExpired":true,
            "enabled":true,
            "apptype":0
          }
        ]
      },
      "returncode":"0",
      "errormsg":"ok"
    }
  },
  // 维护组管理-绑定成员
  {
    url: "/mock/mentenacegroup/bindMentenacemember",
    response: {
      "returncode|+1": ["0", "1"],
      "errormsg|+1": ["操作成功", "操作失败"]
    }
  },
];
